import React from "react"
import { useState, useEffect } from 'react';
import { Form, Table, Row, Col, Container, OverlayTrigger, Tooltip, Button, Spinner, Alert } from "react-bootstrap"
import { IoMdDownload } from "react-icons/io"
import { MdDelete } from "react-icons/md"
import { FaUndo } from "react-icons/fa"
import { statiProposta } from "../../../Utilities/statiElementEnum";
import AllegatoService from "../../../../services/AllegatoService";

var fileDownload = require('js-file-download');

export default function AllegatiProposta(props) {

    const [rowsToMarkToDelete, setRowsToMarkToDelete] = useState([])
    const [allegatoInDownload, setAllegatoInDownload] = useState(null)
    const [erroreDownload, setErroreDownload] = useState(false)

    const ordinaAllegati = (a, b) => {
        return a.allNome.localeCompare(b.allNome);
    }

    // AI generated: il contenuto del file non arriva più con l'elenco dei bilanci (in base64
    // appesantiva enormemente il payload): si scarica da qui, un allegato per volta.
    async function downloadAllegato(allegato) {
        setAllegatoInDownload(allegato.allId)
        setErroreDownload(false)

        try {
            const res = await AllegatoService.getAllegato(allegato.allId)
            const base64Response = await fetch(`data:file;base64,${res.data.allFile}`);
            const blob = await base64Response.blob();
            fileDownload(blob, allegato.allNome);
        } catch (err) {
            console.error("Errore nel download dell'allegato", err)
            setErroreDownload(true)
        } finally {
            setAllegatoInDownload(null)
        }
    }

    const markAllegatoToDelete = (allegato, action) => {
        if (action === 'delete') {
            if (props.allegatiToDelete.filter(all => (all.allId === allegato.allId)).length === 0) {
                props.setAllegatiToDelete([...props.allegatiToDelete, allegato])
                setRowsToMarkToDelete(rowsToMarkToDelete.map(el => { if (el.id === allegato.allId) return { id: allegato.allId, toDelete: true }; return el }))
            }
        }

        if (action === 'resume') {
            if (props.allegatiToDelete.filter(all => (all.allId === allegato.allId)).length === 1) {
                props.setAllegatiToDelete(props.allegatiToDelete.filter(el => el.allId !== allegato.allId))
                setRowsToMarkToDelete(rowsToMarkToDelete.map(el => { if (el.id === allegato.allId) return { id: allegato.allId, toDelete: false }; return el }))
            }
        }
    }

    useEffect(() => {
        if (props.allegati.length > 0)
            setRowsToMarkToDelete(props.allegati.map(el => { return { id: el.allId, toDelete: false } }))
    }, [props.allegati])

    const getIsToDelete = (id) => {
        if (
            rowsToMarkToDelete.filter(el => el.id === id).length > 0 &&
            rowsToMarkToDelete.filter(el => el.id === id)[0].toDelete === true
        ) {
            return true
        }

        return false
    }

    return (
        <>
            {
                props.allegati.length > 0 &&
                <Row>
                    <Col>
                        <Form.Group className="mt-3 mb-1">
                            <Form.Label>
                                <strong>Allegati </strong>
                            </Form.Label>
                        </Form.Group>
                        {erroreDownload &&
                            <Alert
                                variant="danger"
                                onClose={() => { setErroreDownload(false) }}
                                dismissible
                            >
                                Non è stato possibile scaricare l'allegato. Riprova.
                            </Alert>
                        }
                        <Table striped bordered hover responsive className="allegatiProposta">
                            <thead>
                                <tr>
                                    <th style={{ width: "65%" }}>Titolo</th>
                                    <th className="text-center" style={{ width: "20%" }}>Dimensione</th>
                                    <th className="text-center" style={{ width: "15%" }}>Azioni</th>
                                </tr>
                            </thead>
                            <tbody style={{ verticalAlign: "middle" }}>
                                {
                                    props.allegati
                                        .sort(ordinaAllegati)
                                        .map(allegato => (
                                            <tr
                                                key={allegato.allId}
                                                className={getIsToDelete(allegato.allId) === true ? "toDelete" : ""}
                                            >
                                                <td>{allegato.allNome}</td>
                                                <td className="text-center">
                                                    {allegato.allSize &&
                                                    Math.ceil(allegato.allSize / 1024)  + "kb"}
                                                </td>
                                                <td className="text-center">
                                                    <Container className="d-flex justify-content-between py-0 px-3 m-0">
                                                        <OverlayTrigger
                                                            placement="bottom"
                                                            overlay={
                                                                <Tooltip>Scarica</Tooltip>
                                                            }
                                                        >
                                                            <Button
                                                                variant="noBackground"
                                                                onClick={() => { downloadAllegato(allegato) }}
                                                                disabled={allegatoInDownload !== null}
                                                                className="download"
                                                            >
                                                                {allegatoInDownload === allegato.allId ?
                                                                    <Spinner animation="border" size="sm" />
                                                                    :
                                                                    <IoMdDownload style={{ fontSize: "1.5em" }} />
                                                                }
                                                            </Button>
                                                        </OverlayTrigger>
                                                        {getIsToDelete(allegato.allId) === false ?
                                                            (props.statoProposta !== statiProposta.Rifiutata &&
                                                                <OverlayTrigger
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip>Elimina</Tooltip>
                                                                }
                                                            >
                                                                <Button
                                                                    variant="noBackground"
                                                                    disabled={props.readOnly}
                                                                    onClick={() => { markAllegatoToDelete(allegato, 'delete') }}
                                                                >
                                                                    <MdDelete style={{ fontSize: "1.5em" }} />
                                                                </Button>
                                                            </OverlayTrigger>
                                                            )
                                                            :
                                                            <OverlayTrigger
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip>Ripristina</Tooltip>
                                                                }
                                                            >
                                                                <Button
                                                                    variant="noBackground"
                                                                    onClick={() => { markAllegatoToDelete(allegato, 'resume') }}
                                                                    className="resume"
                                                                >
                                                                    <FaUndo style={{ fontSize: "1.1em" }} />
                                                                </Button>
                                                            </OverlayTrigger>
                                                        }
                                                    </Container >
                                                </td>
                                            </tr>
                                        ))
                                }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            }
        </>
    )
}